import { useSite } from "@/context/SiteContext";
import { fmt } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

const Block = ({ id, title, children }) => (
  <section id={id} className="mt-12 scroll-mt-28">
    <h2 className="font-display text-2xl font-semibold">{title}</h2>
    <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-[#3a3935]">{children}</div>
  </section>
);

export default function Privacy() {
  const { config } = useSite();
  const g = config.game;
  usePageMeta("Məxfilik siyasəti və endirim şərtləri", "livemedia.az məxfilik siyasəti və LiveMedia Challenge endirim şərtləri.");
  return (
    <div data-testid="privacy-page" className="pt-32 pb-24">
      <div className="container-lm max-w-3xl">
        <p className="eyebrow">Hüquqi məlumat</p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-4">Məxfilik siyasəti və endirim şərtləri</h1>
        <Block id="mexfilik" title="1. Hansı məlumatları toplayırıq">
          <p>Yalnız formaları könüllü doldurduğunuz zaman göndərdiyiniz məlumatları saxlayırıq: ad, soyad, telefon nömrəsi, seçdiyiniz xidmət və layihə haqqında qısa məlumat.</p>
          <p>Ziyarətlərin sayını hesablamaq üçün IP ünvanınız açıq şəkildə saxlanılmır — yalnız geri çevrilməyən şifrələnmiş (hash) forması, cihaz növü və saytı hansı mənbədən açdığınız qeyd olunur.</p>
          <p>Oyunun həftəlik reytinqində yalnız hədiyyə üçün müraciət göndərən oyunçuların adı və soyadının ilk hərfi göstərilir (məs. «Aysel M.»); telefon nömrəsi heç vaxt göstərilmir.</p>
          <p>Qiymət kalkulyatorundan istifadə etdikdə seçdiyiniz paket, səhifə sayı, funksiyalar və göstərilən qiymət anonim şəkildə (ad və telefon olmadan) saxlanılır və 90 gündən sonra avtomatik silinir.</p>
          <p>Oyun zamanı anonim oyun sessiyası (nəticə, gedişlər, vaxt) saxlanılır. Oyun üçün qeydiyyat tələb olunmur və telefon nömrəniz gizli şəkildə toplanmır.</p>
        </Block>
        <Block title="2. Məlumatlardan necə istifadə edirik">
          <p>Məlumatlar yalnız sizinlə əlaqə saxlamaq, müraciətinizi emal etmək və endirim hüququnu təsdiqləmək üçün istifadə olunur. Məlumatlarınız üçüncü şəxslərə satılmır və ictimai qruplarda paylaşılmır.</p>
          <p>Müraciət barədə bildiriş yalnız sayt sahibinin şəxsi kanalına göndərilir.</p>
        </Block>
        <Block title="3. Saxlama və silinmə">
          <p>Müraciətlər əməkdaşlıq müddətində və qanunvericiliyin tələb etdiyi müddət ərzində saxlanılır. Məlumatlarınızın silinməsini istəsəniz, bizimlə əlaqə saxlayın.</p>
        </Block>
        <Block id="endirim" title="4. LiveMedia Challenge hədiyyə şərtləri">
          <ul className="list-disc pl-5 space-y-2">
            <li>Bir raund {g.duration_sec} saniyə davam edir. Hədəf — {fmt(g.target_score)} xal.</li>
            <li>Hədəfə çatan iştirakçı 6 hədiyyə qutusundan birini seçmək <b>hüququ</b> qazanır. Qutular hər dəfə qarışdırılır, hədiyyə təsadüfi müəyyən edilir.</li>
            <li>Hədiyyə (endirim və ya xidmət) layihənin həcmi müzakirə edildikdən sonra sayt sahibi tərəfindən təsdiqlənir.</li>
            <li>Hədiyyə seçildiyi andan {config.gift_valid_hours || 72} saat ərzində müraciət göndərildikdə qüvvədədir.</li>
            <li>Nəticə serverdə gedişlərin ardıcıllığı və vaxt əsasında yoxlanılır. Avtomatlaşdırılmış və ya saxtalaşdırılmış nəticələr etibarsız sayılır.</li>
            <li>Bir oyun sessiyası üçün yalnız bir müraciət qəbul edilir. Hədiyyə digər aksiyalarla birləşdirilmir və pula çevrilmir.</li>
            <li>Cəhdlərin sayı tezlik baxımından məhdudlaşdırıla bilər.</li>
          </ul>
        </Block>
      </div>
    </div>
  );
}
